import React from "react"
import { Popover } from "../../../../ui/Popover"
import ChevronLeft from "@material-ui/icons/ChevronLeft"
import BreadcrumbRight from "../../../../assets/Chart/breadcrumb-arrow.svg"
import { useMediaQuery } from "@material-ui/core"
import { useHistory } from "react-router-dom"

const MainHeader = ({ header, fieldName, isMobile }) => {
    const history = useHistory()

    const smallMedia = useMediaQuery("(max-width: 640px)")

    return (
        <div className="main__header__title-container">
            <Popover text="Go back">
                <ChevronLeft
                    id="go-back-icon__dashboard"
                    onClick={() => {
                        history.goBack()
                    }}
                    className="main__header__title-return-icon clickable"
                />
            </Popover>

            {!smallMedia && (
                <>
                    <div className="main__header__title-model">{header}</div>
                    <img alt="" className="main__header__title-icon" src={BreadcrumbRight} />                </>
            )}

            <div className="main__header__title-field">{fieldName}</div>
        </div>
    )
}

export default MainHeader
